/**
 * @generated SignedSource<<bd5b326ce6922b55b297bb4066143bb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePersistentWorkerPoolInput = {
  clientMutationId: string;
  enabledForPublic: boolean;
  name: string;
  ownerUid: string;
  platform: string;
};
export type PersistentWorkerPoolsListCreateMutation$variables = {
  input: CreatePersistentWorkerPoolInput;
};
export type PersistentWorkerPoolsListCreateMutation$data = {
  readonly createPersistentWorkerPool: {
    readonly pool: {
      readonly id: string;
    };
  };
};
export type PersistentWorkerPoolsListCreateMutation = {
  response: PersistentWorkerPoolsListCreateMutation$data;
  variables: PersistentWorkerPoolsListCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreatePersistentWorkerPoolPayload",
    "kind": "LinkedField",
    "name": "createPersistentWorkerPool",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PersistentWorkerPool",
        "kind": "LinkedField",
        "name": "pool",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PersistentWorkerPoolsListCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PersistentWorkerPoolsListCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f7728f7fcbec1f65b21567a77cb9d2d",
    "id": null,
    "metadata": {},
    "name": "PersistentWorkerPoolsListCreateMutation",
    "operationKind": "mutation",
    "text": "mutation PersistentWorkerPoolsListCreateMutation(\n  $input: CreatePersistentWorkerPoolInput!\n) {\n  createPersistentWorkerPool(input: $input) {\n    pool {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3cbcce20e7df99fe2a91c64825ab71a8";

export default node;
